"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DevCycleClient = exports.isDeferredOptions = void 0;
var Variable_1 = require("./Variable");
var Request_1 = require("./Request");
var CacheStore_1 = __importDefault(require("./CacheStore"));
var DefaultStorage_1 = __importDefault(require("./DefaultStorage"));
var User_1 = require("./User");
var EventQueue_1 = require("./EventQueue");
var utils_1 = require("./utils");
var EventEmitter_1 = require("./EventEmitter");
var types_1 = require("@devcycle/types");
var ConfigRequestConsolidator_1 = require("./ConfigRequestConsolidator");
var logger_1 = require("./logger");
var StreamingConnection_1 = require("./StreamingConnection");
var isDeferredOptions = function (arg) {
    return !!arg && 'deferInitialization' in arg;
};
exports.isDeferredOptions = isDeferredOptions;
var DevCycleClient = /** @class */ (function () {
    function DevCycleClient(sdkKey, userOrOptions, optionsArg) {
        if (optionsArg === void 0) { optionsArg = {}; }
        var _this = this;
        this._isInitialized = false;
        this.userSaved = false;
        this._closing = false;
        this.isConfigCached = false;
        this.initializeTriggered = false;
        /**
         * Logic to initialize the client with the appropriate user and configuration data by making requests to DevCycle
         * and loading from local storage. This either happens immediately on client initialization, or when the user is
         * first identified (in deferred mode)
         * @param initialUser
         */
        this.clientInitialization = function (initialUser) { return __awaiter(_this, void 0, void 0, function () {
            var storedAnonymousId, _a, err_1;
            var _this = this;
            var _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (this.initializeTriggered || this._closing) {
                            return [2 /*return*/, this];
                        }
                        this.initializeTriggered = true;
                        if (!initialUser.user_id) return [3 /*break*/, 1];
                        _a = undefined;
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.store.loadAnonUserId()];
                    case 2:
                        _a = _d.sent();
                        _d.label = 3;
                    case 3:
                        storedAnonymousId = _a;
                        this.user = new User_1.DVCPopulatedUser(initialUser, this.options, undefined, storedAnonymousId);
                        if (!!this.options.bootstrapConfig) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.getConfigCache(this.user)];
                    case 4:
                        _d.sent();
                        _d.label = 5;
                    case 5:
                        // set up requestConsolidator and hook up callback methods
                        this.requestConsolidator = new ConfigRequestConsolidator_1.ConfigRequestConsolidator(function (user, extraParams) {
                            return (0, Request_1.getConfigJson)(_this.sdkKey, user, _this.logger, _this.options, extraParams);
                        }, function (config, user) {
                            return _this.handleConfigReceived(config, user, Date.now());
                        }, this.user);
                        _d.label = 6;
                    case 6:
                        _d.trys.push([6, 10, 11, 12]);
                        if (!!this.options.bootstrapConfig) return [3 /*break*/, 8];
                        return [4 /*yield*/, this.requestConsolidator.queue(this.user)];
                    case 7:
                        _d.sent();
                        return [3 /*break*/, 9];
                    case 8:
                        this.handleConfigReceived(this.options.bootstrapConfig, this.user, Date.now());
                        _d.label = 9;
                    case 9: return [3 /*break*/, 12];
                    case 10:
                        err_1 = _d.sent();
                        this.eventEmitter.emitInitialized(false);
                        this.eventEmitter.emitError(err_1);
                        return [2 /*return*/, this];
                    case 11:
                        this.resolveOnInitialized(this);
                        this.logger.info('Client initialized');
                        return [7 /*endfinally*/];
                    case 12:
                        this.eventEmitter.emitInitialized(true);
                        if (this.user.isAnonymous) {
                            this.store.saveAnonUserId(this.user.user_id);
                        }
                        else {
                            this.store.removeAnonUserId();
                        }
                        if ((_c = (_b = this.config) === null || _b === void 0 ? void 0 : _b.sse) === null || _c === void 0 ? void 0 : _c.url) {
                            if (!this.options.disableRealtimeUpdates) {
                                this.streamingConnection = new StreamingConnection_1.StreamingConnection(this.config.sse.url, this.onSSEMessage.bind(this), this.logger);
                            }
                            else {
                                this.logger.info('Disabling Realtime Updates based on Initialization parameter');
                            }
                        }
                        return [2 /*return*/, this];
                }
            });
        }); };
        var user;
        var options = optionsArg;
        if ((0, exports.isDeferredOptions)(userOrOptions)) {
            options = userOrOptions;
        }
        else {
            user = userOrOptions;
        }
        this.logger =
            options.logger || (0, logger_1.dvcDefaultLogger)({ level: options.logLevel });
        this.store = new CacheStore_1.default(options.storage || new DefaultStorage_1.default(), this.logger);
        this.options = options;
        this.sdkKey = sdkKey;
        this.variableDefaultMap = {};
        this.eventQueue = new EventQueue_1.EventQueue(sdkKey, this, options);
        this.eventEmitter = new EventEmitter_1.EventEmitter();
        this.registerVisibilityChangeHandler();
        this.onInitialized = new Promise(function (resolve, reject) {
            _this.resolveOnInitialized = function (value) {
                _this._isInitialized = true;
                resolve(value);
            };
        });
        if (!this.options.deferInitialization) {
            if (!user) {
                throw new Error('User must be provided to initialize SDK');
            }
            void this.clientInitialization(user);
        }
        else if (this.options.bootstrapConfig) {
            throw new Error('bootstrapConfig option can not be combined with deferred initialization!');
        }
        if (!(options === null || options === void 0 ? void 0 : options.reactNative) && typeof window !== 'undefined') {
            this.windowMessageHandler = function (event) {
                var message = event.data;
                if ((message === null || message === void 0 ? void 0 : message.type) === 'DVC.optIn.saved') {
                    _this.refetchConfig(false);
                }
            };
            window.addEventListener('message', this.windowMessageHandler);
            this.windowPageHideHandler = function () {
                _this.flushEvents();
            };
            window.addEventListener('pagehide', this.windowPageHideHandler);
        }
    }
    Object.defineProperty(DevCycleClient.prototype, "isInitialized", {
        get: function () {
            return this._isInitialized;
        },
        enumerable: false,
        configurable: true
    });
    DevCycleClient.prototype.onClientInitialized = function (onInitialized) {
        var _this = this;
        if (onInitialized && typeof onInitialized === 'function') {
            this.onInitialized
                .then(function () { return onInitialized(null, _this); })
                .catch(function (err) { return onInitialized(err); });
            return;
        }
        return this.onInitialized;
    };
    /**
     * Get variable object associated with Features. Use the variable's key to fetch the DVCVariable object.
     * If the user does not receive the feature, the default value is used in the returned DVCVariable object.
     * DVCVariable is returned, which has a `value` property that is used to grab the variable value,
     * and a convenience method to pass in a callback to notify the user when the value has changed from the server.
     *
     * @param key
     * @param defaultValue
     */
    DevCycleClient.prototype.variable = function (key, defaultValue) {
        var _a;
        var _b, _c;
        if (defaultValue === undefined || defaultValue === null) {
            throw new Error('Default value is a required param');
        }
        // this will throw if type is invalid
        var type = (0, types_1.getVariableTypeFromValue)(defaultValue, key, this.logger, true);
        var defaultValueKey = typeof defaultValue === 'string'
            ? defaultValue
            : JSON.stringify(defaultValue);
        var variable;
        if (this.variableDefaultMap[key] &&
            this.variableDefaultMap[key][defaultValueKey]) {
            variable = this.variableDefaultMap[key][defaultValueKey];
        }
        else {
            var configVariable = (_c = (_b = this.config) === null || _b === void 0 ? void 0 : _b.variables) === null || _c === void 0 ? void 0 : _c[key];
            var data = {
                key: key,
                defaultValue: defaultValue,
            };
            if (configVariable) {
                if (configVariable.type === type) {
                    data.value = configVariable.value;
                    data.evalReason = configVariable.evalReason;
                }
                else {
                    this.logger.warn("Type mismatch for variable ".concat(key, ". Expected ").concat(type, ", got ").concat(configVariable.type));
                }
            }
            variable = new Variable_1.DVCVariable(data);
            this.variableDefaultMap[key] = __assign((_a = {}, _a[defaultValueKey] = variable, _a), this.variableDefaultMap[key]);
        }
        this.trackVariableEvaluated(variable);
        this.eventEmitter.emitVariableEvaluated(variable);
        return variable;
    };
    DevCycleClient.prototype.trackVariableEvaluated = function (variable) {
        var _a, _b;
        if (this.options.disableAutomaticEventLogging)
            return;
        try {
            var variableFromConfig = (_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.variables) === null || _b === void 0 ? void 0 : _b[variable.key];
            this.eventQueue.queueAggregateEvent({
                type: variable.isDefaulted
                    ? EventQueue_1.EventTypes.variableDefaulted
                    : EventQueue_1.EventTypes.variableEvaluated,
                target: variable.key,
                metaData: {
                    value: variable.value,
                    type: (0, types_1.getVariableTypeFromValue)(variable.defaultValue, variable.key, this.logger),
                    _variable: variableFromConfig === null || variableFromConfig === void 0 ? void 0 : variableFromConfig._id,
                },
            });
        }
        catch (e) {
            this.eventEmitter.emitError(e);
            this.logger.warn("Error with queueing aggregate events ".concat(e));
        }
    };
    /**
     * Get a variable's value associated with a Feature. Use the variable's key to fetch the variable's value.
     * If the user is not segmented into the feature, the default value is returned.
     *
     * @param key
     * @param defaultValue
     */
    DevCycleClient.prototype.variableValue = function (key, defaultValue) {
        return this.variable(key, defaultValue).value;
    };
    DevCycleClient.prototype.identifyUser = function (user, callback) {
        var promise = this._identifyUser(user);
        if (callback && typeof callback == 'function') {
            promise
                .then(function (variables) { return callback(null, variables); })
                .catch(function (err) { return callback(err, null); });
            return;
        }
        return promise;
    };
    DevCycleClient.prototype._identifyUser = function (user) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var updatedUser, storedAnonymousId, config, err_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(this.options.deferInitialization && !this.initializeTriggered)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.clientInitialization(user)];
                    case 1:
                        _b.sent();
                        return [2 /*return*/, ((_a = this.config) === null || _a === void 0 ? void 0 : _a.variables) || {}];
                    case 2:
                        this.eventQueue.flushEvents();
                        _b.label = 3;
                    case 3:
                        _b.trys.push([3, 7, , 8]);
                        return [4 /*yield*/, this.onInitialized];
                    case 4:
                        _b.sent();
                        return [4 /*yield*/, this.store.loadAnonUserId()];
                    case 5:
                        storedAnonymousId = _b.sent();
                        if (this.user && user.user_id === this.user.user_id) {
                            updatedUser = this.user.updateUser(user, this.options);
                        }
                        else {
                            updatedUser = new User_1.DVCPopulatedUser(user, this.options, undefined, storedAnonymousId);
                        }
                        return [4 /*yield*/, this.requestConsolidator.queue(updatedUser)];
                    case 6:
                        config = _b.sent();
                        if (user.isAnonymous || !user.user_id) {
                            this.store.saveAnonUserId(updatedUser.user_id);
                        }
                        return [2 /*return*/, config.variables || {}];
                    case 7:
                        err_2 = _b.sent();
                        this.eventEmitter.emitError(err_2);
                        throw err_2;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    DevCycleClient.prototype.resetUser = function (callback) {
        var _this = this;
        var oldAnonymousId;
        var anonUser = new User_1.DVCPopulatedUser({ isAnonymous: true }, this.options);
        var promise = new Promise(function (resolve, reject) {
            _this.eventQueue.flushEvents();
            _this.onInitialized
                .then(function () { return _this.store.loadAnonUserId(); })
                .then(function (cachedAnonId) {
                _this.store.removeAnonUserId();
                oldAnonymousId = cachedAnonId;
                return;
            })
                .then(function () { return _this.requestConsolidator.queue(anonUser); })
                .then(function (config) {
                _this.store.saveAnonUserId(anonUser.user_id);
                resolve(config.variables || {});
            })
                .catch(function (e) {
                _this.eventEmitter.emitError(e);
                if (oldAnonymousId) {
                    _this.store.saveAnonUserId(oldAnonymousId);
                }
                reject(e);
            });
        });
        if (callback && typeof callback == 'function') {
            promise
                .then(function (variables) { return callback(null, variables); })
                .catch(function (err) { return callback(err, null); });
            return;
        }
        return promise;
    };
    /**
     * Retrieve data on all Features, Object mapped by feature `key`.
     * Use the `DVCFeature.segmented` value to determine if the user was segmented into a
     * feature's audience.
     */
    DevCycleClient.prototype.allFeatures = function () {
        var _a;
        return ((_a = this.config) === null || _a === void 0 ? void 0 : _a.features) || {};
    };
    /**
     * Retrieve data on all Variables, Object mapped by variable `key`.
     */
    DevCycleClient.prototype.allVariables = function () {
        var _a;
        return ((_a = this.config) === null || _a === void 0 ? void 0 : _a.variables) || {};
    };
    DevCycleClient.prototype.subscribe = function (key, handler) {
        this.eventEmitter.subscribe(key, handler);
    };
    /**
     * Unsubscribe to remove existing event emitter subscription.
     *
     * @param key
     * @param handler
     */
    DevCycleClient.prototype.unsubscribe = function (key, handler) {
        this.eventEmitter.unsubscribe(key, handler);
    };
    /**
     * Track Event to DevCycle
     *
     * @param event
     */
    DevCycleClient.prototype.track = function (event) {
        var _this = this;
        if (this._closing) {
            this.logger.error('Client is closing, cannot track new events.');
            return;
        }
        if (this.options.disableCustomEventLogging)
            return;
        (0, utils_1.checkParamDefined)('type', event.type);
        this.onInitialized.then(function () {
            _this.eventQueue.queueEvent(event);
        });
    };
    /**
     * Flush all queued events to DevCycle
     *
     * @param callback
     */
    DevCycleClient.prototype.flushEvents = function (callback) {
        return this.eventQueue.flushEvents().then(function () { return callback === null || callback === void 0 ? void 0 : callback(); });
    };
    /**
     * Close all open connections to DevCycle, flush any pending events and
     * stop any running timers and event handlers. Use to clean up a client instance
     * that is no longer needed.
     */
    DevCycleClient.prototype.close = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.logger.debug('Closing client');
                        this._closing = true;
                        if (document && this.pageVisibilityHandler) {
                            document.removeEventListener('visibilitychange', this.pageVisibilityHandler);
                        }
                        if (this.windowMessageHandler) {
                            window.removeEventListener('message', this.windowMessageHandler);
                        }
                        if (this.windowPageHideHandler) {
                            window.removeEventListener('pagehide', this.windowPageHideHandler);
                        }
                        (_a = this.streamingConnection) === null || _a === void 0 ? void 0 : _a.close();
                        return [4 /*yield*/, this.eventQueue.close()];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(DevCycleClient.prototype, "closing", {
        /**
         * Reflects whether `close()` has been called on the client instance.
         */
        get: function () {
            return this._closing;
        },
        enumerable: false,
        configurable: true
    });
    DevCycleClient.prototype.refetchConfig = function (sse, lastModified, etag) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.onInitialized];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.requestConsolidator.queue(null, { sse: sse, lastModified: lastModified, etag: etag })];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DevCycleClient.prototype.handleConfigReceived = function (config, user, dateFetched) {
        var _this = this;
        var _a;
        var oldConfig = this.config;
        this.config = config;
        this.store.saveConfig(config, user, dateFetched);
        this.isConfigCached = false;
        if (this.user != user || !this.userSaved) {
            this.user = user;
            this.store.saveUser(user);
            if (!this.user.isAnonymous &&
                checkIfEdgeEnabled(config, this.logger, (_a = this.options) === null || _a === void 0 ? void 0 : _a.enableEdgeDB, true)) {
                (0, Request_1.saveEntity)(this.user, this.sdkKey, this.logger, this.options).then(function (res) {
                    return _this.logger.info("Saved response entity! ".concat(res));
                });
            }
            this.userSaved = true;
        }
        var oldFeatures = (oldConfig === null || oldConfig === void 0 ? void 0 : oldConfig.features) || {};
        var oldVariables = (oldConfig === null || oldConfig === void 0 ? void 0 : oldConfig.variables) || {};
        this.eventEmitter.emitFeatureUpdates(oldFeatures, config.features);
        this.eventEmitter.emitVariableUpdates(oldVariables, config.variables, this.variableDefaultMap);
        if (!oldConfig || oldConfig.etag !== this.config.etag) {
            this.eventEmitter.emitConfigUpdate(config.variables);
        }
    };
    DevCycleClient.prototype.onSSEMessage = function (message) {
        var _this = this;
        var _a, _b;
        try {
            var parsedMessage = JSON.parse(message);
            var messageData = JSON.parse(parsedMessage.data);
            if (!messageData) {
                return;
            }
            if (!messageData.type || messageData.type === 'refetchConfig') {
                if (!((_a = this.config) === null || _a === void 0 ? void 0 : _a.etag) ||
                    messageData.etag !== ((_b = this.config) === null || _b === void 0 ? void 0 : _b.etag)) {
                    this.refetchConfig(true, messageData.lastModified, messageData.etag).catch(function (e) {
                        _this.logger.warn("Failed to refetch config ".concat(e));
                    });
                }
            }
        }
        catch (e) {
            this.logger.warn("Streaming Connection: Unparseable message ".concat(e));
        }
    };
    DevCycleClient.prototype.registerVisibilityChangeHandler = function () {
        var _this = this;
        var _a, _b, _c;
        if (typeof document === 'undefined') {
            return;
        }
        var inactivityDelay = ((_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.sse) === null || _b === void 0 ? void 0 : _b.inactivityDelay) || 120000;
        this.pageVisibilityHandler = function () {
            var _a, _b, _c;
            if (!((_a = _this.config) === null || _a === void 0 ? void 0 : _a.sse)) {
                return;
            }
            else if (document.visibilityState === 'visible') {
                if (!((_b = _this.streamingConnection) === null || _b === void 0 ? void 0 : _b.isConnected())) {
                    _this.logger.debug('Page became visible, refetching config');
                    _this.refetchConfig(false).catch(function (e) {
                        _this.logger.warn("Failed to refetch config ".concat(e));
                    });
                    (_c = _this.streamingConnection) === null || _c === void 0 ? void 0 : _c.reopen();
                }
                window === null || window === void 0 ? void 0 : window.clearTimeout(_this.inactivityHandlerId);
            }
            else {
                window === null || window === void 0 ? void 0 : window.clearTimeout(_this.inactivityHandlerId);
                _this.inactivityHandlerId = window === null || window === void 0 ? void 0 : window.setTimeout(function () {
                    var _a;
                    _this.logger.debug('Page is not visible, closing streaming connection');
                    (_a = _this.streamingConnection) === null || _a === void 0 ? void 0 : _a.close();
                }, inactivityDelay);
            }
        };
        (_c = document.addEventListener) === null || _c === void 0 ? void 0 : _c.call(document, 'visibilitychange', this.pageVisibilityHandler);
    };
    DevCycleClient.prototype.getConfigCache = function (user) {
        return __awaiter(this, void 0, void 0, function () {
            var cachedConfig;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.options.disableConfigCache) {
                            this.logger.info('Skipping config cache');
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.store.loadConfig(user, this.options.configCacheTTL)];
                    case 1:
                        cachedConfig = _a.sent();
                        if (cachedConfig) {
                            this.config = cachedConfig;
                            this.isConfigCached = true;
                            this.eventEmitter.emitFeatureUpdates({}, cachedConfig.features);
                            this.eventEmitter.emitVariableUpdates({}, cachedConfig.variables, this.variableDefaultMap);
                            this.logger.debug('Initialized with a cached config');
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return DevCycleClient;
}());
exports.DevCycleClient = DevCycleClient;
var checkIfEdgeEnabled = function (config, logger, enableEdgeDB, logWarning) {
    var _a, _b;
    if (logWarning === void 0) { logWarning = false; }
    if ((_b = (_a = config.project.settings) === null || _a === void 0 ? void 0 : _a.edgeDB) === null || _b === void 0 ? void 0 : _b.enabled) {
        return !!enableEdgeDB;
    }
    else {
        if (enableEdgeDB && logWarning) {
            logger.warn('EdgeDB is not enabled for this project. Only using local user data.');
        }
        return false;
    }
};
//# sourceMappingURL=Client.js.map